import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import { useTranslation } from "react-i18next";
import UsersActivities from "./UsersActivities";

/**
 * @namespace UserActivity
 */

const UserActivityPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [
      { label: t("title.journals") },
      { label: t("title.userActivityLog") },
    ];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <UsersActivities />
    </>
  );
};

export default UserActivityPage;
